import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Hotspot { lat: number; lng: number; count: number; location: string; }
export interface CategoryMetric {
  name: string;
  hottestHour: string;
  strongestHour: string;
  weakestHour: string;
  peakHours: string[];
  totalIncidents: number;
  riskScore: number;
}
export interface ChartPayload { data: any; options: any; }
export interface Contributor { name: string; value: number; }

@Injectable({ providedIn: 'root' })
export class RiskService {
  private api = '/api/risk';

  constructor(private http: HttpClient) {}

  /** Overall dashboard score */
  getOverallScore(): Observable<number> {
    return this.http.get<number>(`${this.api}/overall`);
  }

  /** Hotspot points for Leaflet map */
  getHotspots(): Observable<Hotspot[]> {
    return this.http.get<Hotspot[]>(`${this.api}/hotspots`);
  }

  /** Per-category metrics */
  getCategoryMetrics(): Observable<CategoryMetric[]> {
    return this.http.get<CategoryMetric[]>(`${this.api}/categories`);
  }

  /** Time-series breakdown for line chart */
  getDailyBreakdown(): Observable<ChartPayload> {
    return this.http.get<ChartPayload>(`${this.api}/daily`);
  }

  /** Bar-chart counts (day/week/month) */
  getIncidentCounts(): Observable<ChartPayload> {
    return this.http.get<ChartPayload>(`${this.api}/counts`);
  }

  /** Top contributors list */
  getTopContributors(): Observable<Contributor[]> {
    return this.http.get<Contributor[]>(`${this.api}/contributors`);
  }

  /** Total available personnel */
  getTotalPersonnel(): Observable<number> {
    return this.http.get<number>(`${this.api}/personnel`);
  }
}
